module.exports = __webpack_public_path__ + "img/about-img-5.d3c0c301.png";